import React from "react";

export default function ProductIcon({ color = "currentColor" }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1699 16.3903H24.911C24.9271 16.3903 24.9472 16.3903 24.9632 16.3863C25.14 16.3582 25.2565 16.1935 25.2284 16.0167L23.6132 6.0524C23.5891 5.8957 23.4525 5.7832 23.2958 5.7832H12.7851C12.6284 5.7832 12.4918 5.8957 12.4677 6.0524L10.8525 16.0167C10.8485 16.0328 10.8485 16.0528 10.8485 16.0689C10.8485 16.2457 10.9931 16.3903 11.1699 16.3903ZM14.8342 8.51535H21.2427L22.0744 13.6582H13.9985L14.8342 8.51535ZM14.9347 19.8738C14.9105 19.7171 14.7739 19.6046 14.6172 19.6046H4.10653C3.94983 19.6046 3.81323 19.7171 3.78912 19.8738L2.17394 29.8381C2.16992 29.8542 2.16992 29.8743 2.16992 29.8903C2.16992 30.0671 2.31456 30.2118 2.49135 30.2118H16.2324C16.2485 30.2118 16.2686 30.2118 16.2847 30.2078C16.4614 30.1796 16.578 30.0149 16.5498 29.8381L14.9347 19.8738ZM5.32394 27.4796L6.15564 22.3368H12.5641L13.3958 27.4796H5.32394ZM33.8266 29.8381L32.2114 19.8738C32.1873 19.7171 32.0507 19.6046 31.894 19.6046H21.3833C21.2266 19.6046 21.09 19.7171 21.0659 19.8738L19.4507 29.8381C19.4467 29.8542 19.4467 29.8743 19.4467 29.8903C19.4467 30.0671 19.5914 30.2118 19.7681 30.2118H33.5092C33.5253 30.2118 33.5454 30.2118 33.5614 30.2078C33.7342 30.1796 33.8547 30.0149 33.8266 29.8381ZM22.6007 27.4796L23.4324 22.3368H29.8409L30.6726 27.4796H22.6007Z"
        fill="#fff"
        fillOpacity="0.85"
      />
    </svg>
  );
}
